<template>
    <div>
        <!-- <div class="flex justify-between items-center">
            <breadcrumbs>Vacatures</breadcrumbs>
            <link-button :href="route('admin.joboffers.syncall')" method="patch" icon="sync-alt" class="bg-white">Sync all with Algolia</link-button>
        </div> -->

        <h1 class="text-5xl text-teal-800">Vacatures</h1>

        <div class="flex justify-left items-center">

            <div class="flex flex-grow">
                <input type="hidden" v-model="form.orderBy" />
                <input type="hidden" v-model="form.sortOrder" />

                <search-filter v-model="form.search" class="w-full max-w-sm mr-4" @reset="resetFilters" @input="submitSearch">

                    <!-- <label class="block">Bedrijf:</label>
                    <select v-model="form.filter_company" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null" />
                        <option v-for="(company, id) in companies" :key="id" :value="id">{{ company }}</option>
                    </select> -->

                    <div class="flex items-center space-x-2">
                        <div class="w-1/2">
                            <label class="block mt-3">Published:</label>
                            <select v-model="form.published" class="mt-1 w-full form-select" @change="reloadData">
                                <option :value="null"></option>
                                <option value="false">Nee</option>
                                <option value="true">Ja</option>
                            </select>
                        </div>
                        <div class="w-1/2">
                            <label class="block mt-3">Reviewed:</label>
                            <select v-model="form.reviewed" class="mt-1 w-full form-select" @change="reloadData">
                                <option :value="null"></option>
                                <option value="true">Ja</option>
                                <option value="false">Nee</option>
                            </select>
                        </div>
                    </div>

                    <label class="block mt-3">Baan:</label>
                    <select v-model="form.filter_jobtemplate" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null" />
                        <option value="none" >* Geen baan</option>
                        <option value="not-ignored" >* Alle geschikte (groene) banen</option>
                        <option value="ignored" >* Alle te negeren (niet groene) banen</option>
                        <option v-for="(jobtemplate, id) in jobTemplates" :key="id" :value="id">{{ jobtemplate }}</option>
                    </select>

                    <label class="block mt-3">Oorsprong:</label>
                    <select v-model="form.filter_origin" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null"></option>
                        <option value="site">Site</option>
                        <option value="scraper">Scraper</option>
                    </select>
                </search-filter>

                <div class="flex">

                    <div class="flex items-center"
                    >
                        <button v-show="Object.keys(selectedItems).length > 0"
                            @click="publishSelected('published')"
                            class="px-3 py-2 bg-green-100 hover:bg-green-200 rounded"
                        >
                            <i class="fad mr-1" :class="loading === 'multipublished' ? 'block fa-spinner fa-pulse' : 'fa-thumbs-up'"></i>Publiceer selectie ({{ Object.keys(selectedItems).length }})
                        </button>

                        <button v-show="Object.keys(selectedItems).length > 0"
                            @click="publishSelected('unpublished')"
                            class="ml-3 px-3 py-2 bg-red-100 hover:bg-red-200 rounded"
                        >
                            <i class="fad mr-1" :class="loading === 'multiunpublished' ? 'block fa-spinner fa-pulse' : 'fa-thumbs-down'"></i>Depubliceer selectie ({{ Object.keys(selectedItems).length }})
                        </button>
                    </div>
                </div>

            </div>

            <num-results name="vacatures"
                :from="jobOffers.from"
                :to="jobOffers.to"
                :total="jobOffers.total"
            />

        </div>
        <div class="mt-1">
            <active-filters :filters="filters" @remove-filter="removeFilter" />
        </div>

        <p v-if="!jobOffers.data.length">Er zijn geen vacatures gevonden.</p>

        <table v-else class="mt-3 table-fixed w-full whitespace-no-wrap bg-white rounded text-left">
            <thead>
                <tr class="px-3 py-3 text-teal-800 font-bold">

                    <th class="whitespace-nowrap px-3 py-3 text-center" width="30">
                        <input type="checkbox" v-model="selectAll" @change="toggleSelectAll()" />
                    </th>

                    <th class="whitespace-nowrap px-3 py-3 text-center" width="30">
                    </th>

                    <th class="whitespace-nowrap px-3 py-3" width="80">
                        <a href @click.prevent="sort('id')" class="hover:underline">ID<sort-icon col="id" :orderby="filters.orderBy" :sortorder="filters.sortOrder" /> </a>
                    </th>

                    <!-- <th classpx-3 ="py-3" width="120">
                        <a href @click.prevent="sort('created_at')" class="hover:underline">
                            <i class="fal fa-calendar-plus mr-1"></i>Created<sort-icon col="created_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th> -->


                    <!-- <th classpx-3 ="py-3" width="50">
                        <a href @click.prevent="sort('published')" class="hover:underline">
                            <i class="fad fa-leaf mr-1"></i>
                            <sort-icon col="published" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th> -->

                    <th class="whitespace-nowrap px-3 py-3" width="76">
                        <a href @click.prevent="sort('sustainability_score')" class="hover:underline">
                            Score: <sort-icon col="sustainability_score" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>

                    <th class="whitespace-nowrap px-3 py-3">
                        <a href @click.prevent="sort('title')" class="hover:underline">
                            Title<sort-icon col="title" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>

                    <th class="whitespace-nowrap px-3 py-3"><i class="fal fa-user-md mr-1"></i>Baan</th>

                    <th class="whitespace-nowrap px-3 py-3"><i class="fal fa-building mr-1"></i>Company</th>

                    <th class="px-3 py-3">
                        <a href @click.prevent="sort('tags_count')" class="hover:underline">
                            <i class="fad fa-tags mr-1"></i>Tags
                            <sort-icon col="tags_count" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>

                    <th class="whitespace-nowrap px-3 py-3" width="120">
                        <a href @click.prevent="sort('updated_at')" class="hover:underline">
                            <i class="fal fa-calendar-edit mr-1"></i>Created<sort-icon col="created_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>

                    <th class="whitespace-nowrap px-3 py-3" width="120">
                      <a href @click.prevent="sort('closed_at')" class="hover:underline">
                        <i class="fal fa-calendar-check mr-1"></i>Closes<sort-icon col="closed_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                      </a>
                    </th>

                    <th class="whitespace-nowrap px-3 py-3" width="150">
                        <a href @click.prevent="sort('published_at')" class="hover:underline">
                            <i class="fal fa-calendar-check mr-1"></i>Published<sort-icon col="published_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>
                    <th class="whitespace-nowrap px-3 py-3" width="120">
                        <a href @click.prevent="sort('reviewed_at')" class="hover:underline">
                            <i class="fal fa-calendar-check mr-1"></i>Reviewed<sort-icon col="reviewed_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>

                    <th width="130"></th>
                </tr>
            </thead>

            <tr
                v-for="(jobOffer, index) in jobOffers.data"
                :key="jobOffer.id"
                class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900"
                :class="{
                    'bg-teal-100': !(index % 2),
                    'text-gray-500': jobOffer.deleted_at
                }"
            >
                <td class="px-3 border-t">
                  <input type="checkbox" v-model="selectedItems[jobOffer.id]" />
                </td>

                <td class="border-t">
                    <span class="text-gray-500 mx-3"><i class="fad mr-1" :class="jobOffer.origin === 'scraper' ? 'fa-spider' : 'fa-user'"></i></span>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:font-bold" :href="getJobOfferUrl(jobOffer.id)" tabindex="-1">
                        {{ jobOffer.id }}
                    </inertia-link>
                </td>

                <td class="border-t px-2">
                    {{ jobOffer.sustainability_score }}
                </td>

                <td class="border-t px-2">
                    <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="getJobOfferUrl(jobOffer.id)">
                        <span class="truncate inline-block w-full">{{ jobOffer.title | truncate(50) }}</span>
                    </inertia-link>
                </td>

                <td class="border-t px-2 text-sm">
                    <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="getJobOfferUrl(jobOffer.id)">
                        <span v-if="jobOffer.job_template" class="truncate inline-block w-full">{{ jobOffer.job_template.title | truncate(30) }}</span>
                    </inertia-link>
                </td>

                <td class="border-t px-2 text-sm">
                    <inertia-link v-if="jobOffer.company" class="hover:underline" :href="route('admin.companies.edit', jobOffer.company_id)" tabindex="-1">
                        <span v-if="jobOffer.company.deleted_at" class="line-through"> <i class="fal fa-trash mr-1"></i>{{ jobOffer.company.name }} </span>
                        <span v-else class="truncate inline-block w-full">{{ jobOffer.company.name | truncate(30) }}</span>
                    </inertia-link>
                </td>

                <td class="border-t px-2">
                    <div v-if="jobOffer.tags && jobOffer.tags.length" class="flex overflow-x-auto items-center text-sm mr-2">
                            <span>{{ jobOffer.tags_count }}</span>
                            <i class="fad fa-tags mx-1"></i>
                            <div v-for="(tag) in jobOffer.tags"
                                class="bg-white mr-1 px-2 py-1 my-1 rounded"
                                :key="tag.id"
                            >
                                {{ tag.name }}
                            </div>
                    </div>
                </td>


                <td class="border-t px-2">
                    <inertia-link v-if="jobOffer.created_at" class="py-4 flex items-center" :href="getJobOfferUrl(jobOffer.id)" tabindex="-1">
                        {{ moment(jobOffer.created_at).format("DD-MM-YYYY") }}
                    </inertia-link>
                </td>

                <td class="border-t px-2 text-center hidden xl:table-cell">
                    <inertia-link
                        v-if="jobOffer.origin === 'site'"
                        class="py-4 text-center"
                        :href="getJobOfferUrl(jobOffer.id)"
                        tabindex="-1"
                    >
                      {{ moment(jobOffer.closed_at).format("DD-MM") }}
                    </inertia-link>
                </td>

                <td class="border-t px-2">
                    <inertia-link class="py-4 text-center" :href="getJobOfferUrl(jobOffer.id)" tabindex="-1">
                        <span v-if="jobOffer.published">
                            <i class="fas fa-check-circle mr-1"></i>
                            {{ moment(jobOffer.published_at).format("DD-MM") }}
                        </span>
                        <span v-else>Nee</span>
                    </inertia-link>
                </td>

                <td class="border-t px-2 text-center hidden xl:table-cell">
                    <inertia-link class="py-4 text-center" :href="getJobOfferUrl(jobOffer.id)" tabindex="-1">
                        <span v-if="jobOffer.reviewed">
                            {{ moment(jobOffer.reviewed_at).format("DD-MM") }}
                        </span>
                        <span v-else>Nee</span>
                    </inertia-link>
                </td>

                <td class="border-t px-2 text-sm text-center">

                    <div class="flex justify-center items-center whitespace-nowrap">

                        <div v-if="jobOffer.origin === 'scraper'" class="whitespace-nowrap">
                            <button
                                class="px-2 py-1 rounded hover:text-white hover:bg-green-800"
                                :class="jobOffer.reviewed && jobOffer.published ? 'bg-green-500 text-white font-bold' : 'bg-green-100'"
                                @click.prevent="publish(jobOffer, true)"
                            >
                                <i class="fad" :class="loading === 'publish'+jobOffer.id+'true' ? 'fa-spinner fa-pulse' : 'fa-thumbs-up'"></i>
                            </button>

                            <button
                                class="ml-1 px-2 py-1 rounded hover:text-white hover:bg-red-800"
                                :class="jobOffer.reviewed && !jobOffer.published ? 'bg-red-500 text-white font-bold' : 'bg-red-100'"
                                @click.prevent="publish(jobOffer, false)"
                            >
                                <i class="fad" :class="loading === 'publish'+jobOffer.id+'false' ? 'fa-spinner fa-pulse' : 'fa-thumbs-down'"></i>
                            </button>
                        </div>

                        <a :href="route('site.joboffers.show', jobOffer.slug)"
                            target="_blank"
                            title="Toon op de site"
                            class="ml-3 px-2 py-1 rounded hover:text-white hover:bg-green-800 bg-white">
                            <i class="fad fa-external-link"></i>
                        </a>
                    </div>
                </td>


                <!--
                <td class="text-right pr-5 border-t">
                        <div v-if="jobOffer.scraper_id && jobOffer.scraper_page_id && !jobOffer.deleted_at">
                        <inertia-link
                            :href="`/scrapers/${jobOffer.scraper_id}/pages/${jobOffer.scraper_page_id}/download`"
                            @click="setTempLoading('downloading' + jobOffer.id)"
                            preserve-scroll
                            preserve-state
                            tabindex="-1"
                        >
                            <i
                                class="fas text-teal-600 hover:text-teal-800"
                                :class="loading == 'downloading' + jobOffer.id ? 'fa-spinner fa-spin' : 'fa-download '"
                            ></i>
                        </inertia-link>

                        <inertia-link
                            :href="`/scrapers/${jobOffer.scraper_id}/pages/${jobOffer.scraper_page_id}/parse`"
                            @click="setTempLoading('parsing' + jobOffer.id)"
                            preserve-scroll
                            preserve-state
                            tabindex="-1"
                        >
                            <i
                                class="fas ml-3 text-teal-600 hover:text-teal-800"
                                :class="loading == 'parsing' + jobOffer.id ? 'fa-spinner fa-spin' : 'fa-layer-plus'"
                            ></i>
                        </inertia-link>
                    </div>
                </td>
                    -->
            </tr>
        </table>

        <pagination :links="jobOffers.links" />
    </div>
</template>

<script>
import _ from "lodash";
import Layout from "@/admin/Shared/Layout";
import SortIcon from "@/admin/Shared/SortIcon";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Pagination from "@/admin/Shared/Pagination";
import { Inertia } from "@inertiajs/inertia";
import SearchFilter from "@/admin/Shared/SearchFilter";
import ActiveFilters from "@/admin/Shared/ActiveFilters";
import NumResults from "@/admin/Shared/NumResults";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import LinkButton from "@/admin/Shared/LinkButton";

export default {
    metaInfo: { title: "Job offers" },

    layout: Layout,

    mixins: [Helpers],

    components: {
        Pagination,
        SearchFilter,
        ActiveFilters,
        SortIcon,
        NumResults,
        Breadcrumbs,
        LinkButton
    },

    props: {
        jobOffers: Object,
        paginationInfo: Object,
        filters: Object,
        companies: Object,
        jobTemplates: Object,
    },
    data() {
        return {
            selectAll: false,
            selectedItems: {},

            form: {
                created_at: this.filters.created_at,
                published_at: this.filters.published_at,
                reviewed: this.filters.reviewed,
                published: this.filters.published,
                trashed: this.filters.trashed,
                search: this.filters.search,
                orderBy: this.filters.orderBy,
                sortOrder: this.filters.sortOrder
            }
        };
    },

    methods: {
        parseAll() {
            this.setTempLoading("parseAll");
            this.$eventHub.$emit("set-reloading", true);
        },

        reloadData() {
            let queryParams = _.pickBy(this.form);
            this.$inertia.replace(this.route("admin.joboffers.index", Object.keys(queryParams).length ? queryParams : { remember: "forget" }));
        },

        sort(col) {
            this.form.sortOrder = this.getNewSortOrder(col, this.form.orderBy, this.form.sortOrder);
            this.form.orderBy = col;
            this.reloadData();
        },

        getJobOfferUrl(id) {
            return route("admin.joboffers.show", id) + window.location.search;
        },

        submitSearch: _.debounce(function() {
            this.reloadData();
        }, 250),

        resetFilters() {
            this.form = _.mapValues(this.form, () => null);
            this.reloadData();
        },

        removeFilter(filterName) {
            this.form[filterName] = null;
            this.reloadData();
        },

        publish(jobOffer, published) {
            this.setLoading("publish" + jobOffer.id + published);

            const url = this.route("admin.joboffers.publish", jobOffer.id).url();
            const data = { published: published };

            axios.patch(url, data).then(response => {
                jobOffer.published = response.data.published;
                jobOffer.published_at = response.data.published_at;
                jobOffer.reviewed = response.data.reviewed;
                jobOffer.reviewed_at = response.data.reviewed_at;
                this.setLoading('');
            });
        },

        publishSelected(state){
            this.setLoading('multi'+state);

            const url = this.route("admin.joboffers.actions.publish").url();
            const data = { state: state, job_offers: Object.keys(this.selectedItems) };

            Inertia.patch(url, data, {
                onSuccess: () => {
                    this.loading = ""
                    this.selectedItems = {}
                    this.selectAll = false
                },
            })

        },

        toggleSelectAll(){
            if(this.selectAll === false){
                this.selectedItems = {}
                return;
            }

            Object.entries(this.jobOffers.data).forEach(([key, value]) => {
                this.$set(this.selectedItems, value.id, true)
            })
        }
    }
};
</script>
